import type { ImageUploadResponse } from '@apuestapr/contracts';

import type { ApiResult } from '../api/client.ts';
import { uploadImage } from '../api/upload.ts';

export type ImageUploader = (
  file: File,
  csrfToken: string,
) => Promise<ApiResult<ImageUploadResponse>>;

/** Binds the Task 13 multipart helper to the configured admin API origin. */
export const createImageUploader =
  (baseUrl: string, fetchImpl?: typeof globalThis.fetch): ImageUploader =>
  (file, csrfToken) =>
    uploadImage({
      baseUrl,
      file,
      csrfToken,
      ...(fetchImpl === undefined ? {} : { fetch: fetchImpl }),
    });

export const sameOriginImageUploader = createImageUploader('');
